import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Grid, Row, Col, Label, Glyphicon, Button} from 'react-bootstrap'
import '../containers/css/IdeaPage.css'
import IdeaStage from '../components/IdeaStage'
import TimelineTool from '../components/TimelineTool.js'
import IdeaAttachmentField from '../components/IdeaAttachmentField'
import RecommendationLabel from '../components/RecommendationLabel'
import moment from 'moment'
import Logger from '../stores/Logger'
import * as helpers from '../lib/HelperFunctions'
import {toJS} from 'mobx'
import firebase from '../firebase'
import './css/ViewIdeaPage.css'
import CommentSection from '../components/CommentSection'
import ChatEntry from '../components/ChatEntry'

class ViewIdeaPage extends Component {
    constructor(props) {
        super(props)
        this.doesToolContainAnyData = this.doesToolContainAnyData.bind(this)
        this.dummy = this.dummy.bind(this)
        this.joinIdea = this.joinIdea.bind(this)
        this.state = {
            existingIdeaKey: undefined,
            className: 'commentOpen',
            iconState: 'menu-right',
            loadedTeamStages: [],
            loadedTeamTools: [],
            isMobile: false,
        }
        this.onCollapse = this.onCollapse.bind(this)
        this.onOpen = this.onOpen.bind(this)
    }
    componentWillMount() {
        const { stores } = this.props
        const { store, authStore, prefStore, messageStore, toolStore } = stores

        if (this.props.params.ideaKey) {
            Logger.trackEvent('viewIdeaPage', 'ideaKey', this.props.params.ideaKey)
            let thing = this
            let noTeamStages = toolStore.defaultStages.toJSON()
            let noTeamTools = toolStore.defaultTools.toJSON()
            this.unwatchAuth = authStore.watchAuth(user => {
                if (user) {
                    thing.setState({ existingIdeaKey: thing.props.params.ideaKey })
                    store.loadIdeaWithKey(thing.props.params.ideaKey)
                    prefStore.loadTeamPrefs(thing.props.params.ideaKey).then(() => {

                        if (prefStore.defaultIdeaStages.length > 0){
                            this.setState({
                                loadedTeamStages: prefStore.defaultIdeaStages.toJSON(),
                            })
                        } else {
                            firebase.database().ref().child('stages').once('value',stagesSnap => {
                                if(stagesSnap.exists()){
                                    noTeamStages = stagesSnap.val()
                                    this.setState({
                                        loadedTeamStages: noTeamStages,
                                    })
                                }
                            })
                        }

                        ////////////////////////

                        if (prefStore.defaultIdeaTools.length > 0){
                            this.setState({
                                loadedTeamTools: prefStore.defaultIdeaTools,
                            })
                        } else {
                            firebase.database().ref().child('tools').once('value',toolsSnap => {
                                if(toolsSnap.exists()){
                                    noTeamTools = toolsSnap.val()
                                    this.setState({
                                        loadedTeamTools: noTeamTools,
                                    })
                                }
                            })
                        }
                    })
                    messageStore.loadMessagesForIdea(thing.props.params.ideaKey)
                }
            }, error => {
                console.log('watchAuth error: ' + JSON.stringify(error))
            })
        }
    }
    componentDidMount() {
        window.addEventListener('resize', () => {
            this.setState({ isMobile: window.innerWidth < 1201 })
        }, false)
    }
    componentDidUpdate() {
        this.scrollToBottom()
    }
    componentWillReceiveProps(nextProps) {
        //This is called when a new idea is saved and redirected to own url /idea/<ideaKey>
        const { stores, params } = nextProps
        const { store, messageStore } = stores
        const { ideaKey } = params
        // console.log('componentWillReceiveProps:',ideaKey, ', old one was:',this.state.existingIdeaKey)
        if (ideaKey) {
            store.loadIdeaWithKey(ideaKey)
            messageStore.loadMessagesForIdea(ideaKey)
            // store.loadMessagesForIdea(ideaKey)
            // store.loadSketchForIdea(ideaKey)
        }
    }
    componentWillUpdate() {
        /* const { stores } = this.props
        const { store, authStore, routingStore } = stores
        const { theIdea } = store
        const {push} = routingStore
        let team = authStore.auth.primaryTeam
        var theUser = authStore.authUser()
        let isFound = false
        if (theUser !== undefined) {
            if (team !== undefined && theIdea !== undefined) {
                if (team.hasOwnProperty('key') && team.key && theIdea.hasOwnProperty('teamId') && theIdea.teamId) {
                    if (team.key !== theIdea.teamId) {
                        authStore.findTeam(theIdea.teamId, theUser.uid).then((team) => {
                            if (team !== undefined) {
                                Object.keys(team.val().members).forEach((member, index) => {
                                    if (member === theUser.uid) {
                                        isFound = true
                                    }
                                })
                                if (isFound === true && authStore.auth.manuallyChangedTeams === false){
                                    console.log('IF')
                                    let inIdeaPage = true
                                    authStore.changeTeam(theIdea.teamId, inIdeaPage)
                                    //store.subscribeToAllIdeas()
                                    } else if (authStore.auth.manuallyChangedTeams === true){
                                        console.log('ELSE')
                                        store.manuallyChangedTeams = false
                                        //store.subscribeToAllIdeas()
                                        push('/ideas')
                                }
                            }
                        })
                    }
                }
            }
        } */
        if(this.state.isMobile === true) {
            if(this.state.className !== 'commentOpen') {
                this.onOpen()
            }
        }
    }
    componentWillUnmount() {
        const { stores } = this.props
        const { store, messageStore } = stores
        if (this.state.existingIdeaKey) {
            store.unloadIdea(this.state.existingIdeaKey)
        }
        if (this.unwatchAuth) {
            this.unwatchAuth()
            this.unwatchAuth = null
        }
        messageStore.unloadMessages(this.state.existingIdeaKey)

        window.removeEventListener('resize', () => {
            this.setState({ isMobile: window.innerWidth < 1201 })
        }, false)
    }

    dummy(something) { }


    doesToolContainAnyData(toolName) {
        const { stores } = this.props
        const { store } = stores
        const { theIdea } = store
        let allow = false
        for (var i in theIdea[toolName]) {
            if (theIdea[toolName][i].length > 0) {
                allow = true
            }
        }
        return allow
    }

    onNewMessage(newMessage) {
        const { stores } = this.props
        const { store, messageStore } = stores
        messageStore.newMessage(newMessage, this.state.existingIdeaKey, store.theIdea)
        Logger.trackEvent('onNewMessage', 'length', newMessage.length)
    }
    onCollapse() {
        this.setState({ iconState: 'menu-left' })
        this.setState({ className: 'collapsed' })
    }
    onOpen() {
        this.setState({ iconState: 'menu-right' })
        this.setState({ className: 'commentOpen' })
    }
    scrollToBottom() {
        const commentList = document.getElementById('commentOpen')
        if(commentList !== null) {
            commentList.scrollTop = commentList.scrollHeight
        }
    }
    joinIdea(ideaTeam, user, loadedTeam){
        const {stores} = this.props
        const {store, notificationStore} = stores
        const {theIdea} = store
        var team = toJS(ideaTeam)
        var canAddTeamMember = true
        var maxCollaborators = 100
        if (team){
            canAddTeamMember = (team.length < maxCollaborators) ? true : false
        }
        if(canAddTeamMember){
            if (helpers.validateEmail(user.email)){
                var email = user.email.toLowerCase()
                Logger.trackEvent('joinIdea', 'user email', email.replace(/@/g , '(AT)'))
                store.addMemberToIdea(this.state.existingIdeaKey, email, user.displayName, theIdea.owner)
                store.sharedIdeas = Object.assign({}, store.sharedIdeas, {
                    [this.state.existingIdeaKey]: theIdea,
                })
                notificationStore.createNotificationToTeamMembers(this.state.existingIdeaKey, user.displayName + ' has joined the idea team', theIdea.owner, toJS(theIdea.team), theIdea.responsible, loadedTeam)
            }
        }else{
            Logger.trackEvent('joinIdea failed', 'maxCollaborators reached', email.replace(/@/g , '(AT)'))
        }
    }

    render() {
        const {stores} = this.props
        const {store, authStore, messageStore, routingStore, toolStore, prefStore} = stores
        const {theIdea, theIdeaStatus} = store
        const {push} = routingStore
        const { messages } = messageStore
        let messageLength = 0
        if(messages){
            messageLength = Object.keys(messages).length
        }
        let currentSteps = []
        var theUser = authStore.authUser()
        if (theIdea !== undefined) {
            if (theIdea.hasOwnProperty('timelineRows')) {
                currentSteps = toJS(theIdea.timelineRows)
            }
            else {
                currentSteps = []
            }
        }

        if (theIdeaStatus === 0) {
            return null
        } else if (theIdeaStatus === 403) {
            window.onpopstate = null
            push('/forbidden')
            return null
        } else if (theIdeaStatus === 404) {
            window.onpopstate = null
            push('/notfound')
            return null
        } else if (theIdeaStatus === 500) {
            window.onpopstate = null
            push('/error')
            return null
        }

        let totalCost = 0
        if (theIdea.hasOwnProperty('costRows')) {
            for (let x = 0; x < theIdea.costRows.length; x++) {
                if (theIdea.costRows[x].amount !== undefined) {
                    totalCost += parseFloat(theIdea.costRows[x].amount)
                }
            }
        }

        let totalRevenue = 0
        if (theIdea.hasOwnProperty('revenueRows')) {
            for (let x = 0; x < theIdea.revenueRows.length; x++) {
                if (theIdea.revenueRows[x].amount !== undefined) {
                    totalRevenue += parseFloat(theIdea.revenueRows[x].amount)
                }
            }
        }

        let showToolHeading = false
        for (const tool of toolStore.toolOrder) {
            if (theIdea.hasOwnProperty(tool)) {
                for (let question in theIdea[tool]) {
                    if (theIdea[tool][question].length > 0) {
                        showToolHeading = true
                    }
                }
            }
        }

        if (theIdea.hasOwnProperty('costRows') && theIdea.costRows.length > 0 && theIdea.costRows[0].amount > 0) {
            if (theIdea.costRows.length > 0) {
                showToolHeading = true
            }
        }

        if (theIdea.hasOwnProperty('revenueRows') && theIdea.revenueRows.length > 0 && theIdea.revenueRows[0].amount > 0) {
            if (theIdea.revenueRows.length > 0) {
                showToolHeading = true
            }
        }

        if (theIdea.hasOwnProperty('timelineRows') && theIdea.timelineRows.length > 0) {
            if (theIdea.timelineRows.length > 0) {
                showToolHeading = true
            }
        }

        var date = null
        if (theIdea.timestamp) {
            date = new Date(theIdea.timestamp)
            date = date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear()
        }
        let lastUpdated = null
        if (theIdea.lastUpdated) {
            lastUpdated = moment(theIdea.lastUpdated).fromNow()
        }
        let statusTimestamp = null
        if (theIdea && theIdea.hasOwnProperty('statusTimestamp')){
            statusTimestamp = new Date(theIdea.statusTimestamp)
            statusTimestamp = statusTimestamp.getDate() + '.' + (statusTimestamp.getMonth()+1) + '.' + statusTimestamp.getFullYear()
        }
        let dueDate = null
        if (theIdea.dueDate) {
            dueDate = new Date(theIdea.dueDate)
            dueDate = dueDate.getDate() + '.' + (dueDate.getMonth() + 1) + '.' + dueDate.getFullYear()
        }

        let loadedTeam = prefStore.ideaTeam
        let loadedAllTools = []
        let loadedToolNames = []
        let loadedToolShowname = []
        let loadedIdeaTeam = null

        let showJoinIdeaButton = true

        if (theIdea !== undefined) {
            this.state.loadedTeamTools.forEach(t => {
                let key = Object.keys(t)[0]
                loadedToolNames.push(key)
                loadedAllTools[key] = t[key].tools
                loadedToolShowname[key] = t[key].showName
            })
        }

        let theIdeaStatusAccepted = 'viewPageStatus'
        let theIdeaStatusRejected = 'viewPageStatus'

        if (theIdea && theIdea.hasOwnProperty('status')){
            if(theIdea.status === 'Accepted'){
                theIdeaStatusAccepted = 'viewPageAccepted'
            }
            else if(theIdea.status === 'Rejected'){
                theIdeaStatusRejected = 'viewPageRejected'
            }
        }

        if(theIdea !== undefined){
            if(!theIdea.hasOwnProperty('status')){
                if(theIdea.owner !== theUser.email){
                    if(theIdea.hasOwnProperty('responsible') && theIdea.responsible.userId === theUser.uid){
                        showJoinIdeaButton = false
                    } else if(theIdea.hasOwnProperty('team')){
                        loadedIdeaTeam = theIdea.team
                        showJoinIdeaButton = store.canJoinTheIdea(theIdea.team, theUser.uid)
                    }
                } else {
                    showJoinIdeaButton = false
                }
            } else {
                showJoinIdeaButton = false
            }
        }
        return (
            <div className='viewIdeaPageContainerOpen'>
            <Grid fluid>
                <Row className='commentIdeaRow'>
                {/* <Col lg={8} sm={10} xs={12} className='ideaCol'> */}
                    <Col xs={12} sm={12} lg={9} className='ideaCol'>
                        <h1 id='ideaDescription'>{theIdea.name}</h1>
                        <small>by {theIdea.ownerName} ({theIdea.owner})</small>
                        {theIdea.hasOwnProperty('responsible') &&
                            <small style={{ display: 'block' }}>Responsible: {theIdea.responsible.fullName} ({theIdea.responsible.email})</small>
                        }
                        {date !== null &&
                            <small style={{ display: 'block' }}>
                                Created at: {date}
                            </small>
                        }
                        {(theIdea.dueDate && theIdea.dueDate !== '') &&
                            <small style={{ display: 'block' }}>
                                Due date: {dueDate}
                            </small>
                        }
                        {lastUpdated !== null &&
                            <small style={{ display: 'block' }}>
                                Last updated: {lastUpdated}
                            </small>
                        }
                        {statusTimestamp !== null &&
                             <small style={{display: 'block'}}>
                             Stored to '{theIdea.status}' ideas: {statusTimestamp}
                             </small>
                        }
                        {showJoinIdeaButton === true &&
                            <Button style={{textDecoration: 'none', outline: 'none'}} className='viewIdeaPageJoinIdea' bsStyle='link' onClick={() => this.joinIdea(loadedIdeaTeam, theUser, loadedTeam)}>
                                <strong className='viewIdeaPageJoinIdeaText'>Join idea</strong>
                            </Button>
                        }
                        {theIdea.tags.length>0 &&
                            <div>
                                <h3>Tags</h3>
                                {theIdea.tags.map((tag, index) =>
                                    <div key={index + 1} style={{ display: 'inline-block' }}>
                                        <span className='tagSize' key={index}><Label bsStyle='primary'>{tag}</Label></span>
                                    </div>,
                                )}
                            </div>
                        }

                        {(theIdea.hasOwnProperty('effortRating') && theIdea.hasOwnProperty('impactRating')) &&
                            <div>
                                <h3>Recommendation</h3>
                                <RecommendationLabel
                                    effortRating={theIdea.effortRating}
                                    impactRating={theIdea.impactRating}
                                />
                            </div>
                        }

                        {theIdea.description &&
                            <div>
                                <h3>Description</h3>
                                <p>{theIdea.description}</p>
                            </div>
                        }

                        {theIdea.imageUrl &&
                            <div className='viewIdeaImageContainer'>
                                <h3>Idea image</h3>
                                <img src={theIdea.imageUrl} className='viewIdeaImage' alt='Showing idea' />
                            </div>
                        }

                        {theIdea.need &&
                            <div>
                                <h3>Need</h3>
                                <p>{theIdea.need}</p>
                            </div>
                        }

                        {theIdea.needImageUrl &&
                            <div>
                                <h3>Image showing the need or problem</h3>
                                <img src={theIdea.needImageUrl} className='viewIdeaImage' alt='Showing need or problem' />
                                <br />
                            </div>
                        }

                        <div id='ideaRating'/>
                            {this.state.loadedTeamStages.length > 0  &&
                                <div id='ideaStage' style={{marginTop: 30+'px'}}>
                                    <span className='storedText'>Idea stage</span>
                                    <IdeaStage
                                        stage={theIdea.currentStage}
                                        setStage={this.dummy.bind(this)}
                                        stageNames={this.state.loadedTeamStages}
                                        cursor=''
                                    />
                                    {theIdea && theIdea.hasOwnProperty('status') &&
                                        <div>
                                            <span className='storedText'>Stored</span>
                                            <div className='statusContainer'>
                                                <div className={theIdeaStatusAccepted}>Accepted</div>
                                                <div className={theIdeaStatusRejected}>Rejected</div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        <div id='ideaAddDetails' />
                        {(theIdea.imageUrls.length > 0 || theIdea.gotSketch || theIdea.attachmentUrls.length > 0 || theIdea.moreDescription) &&
                            <h2>More info</h2>
                        }

                        {theIdea.imageUrls.length > 0 &&
                            <div>
                                <h3>More images or graphics</h3>
                                <div>
                                    {theIdea.imageUrls.map((image, index) => (
                                        <div key={index} className='viewAdditionalImages'>
                                            <img key={index + 1} src={theIdea.imageUrls[index]} className='viewIdeaImage' alt='Additional pictures' />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        }

                        {theIdea.imageText &&
                            <p>{theIdea.imageText}</p>
                        }

                        {theIdea.gotSketch &&
                            <div>
                                <h3>Sketches</h3>
                                <img src={theIdea.gotSketch} className='viewIdeaSketch' alt='Sketch' />
                                <p>{theIdea.sketchText}</p>
                            </div>
                        }

                        {theIdea.attachmentUrls.length > 0 &&
                            <div>
                                <h3 style={{ marginBottom: 20 }}>Attachments</h3>
                                <div>{theIdea.attachmentUrls.map((image, index) =>
                                    <div key={index + 1} style={{ display: 'inline-block', width: 50, height: 100, marginRight: 90 }}>
                                        <IdeaAttachmentField
                                            onNewAttachment={this.dummy}
                                            onAttachmentRejected={this.dummy}
                                            attachmentUrl={(theIdea.attachmentUrls.length > index) ? theIdea.attachmentUrls[index] : null}
                                            origFileName={(theIdea.attachmentOrigFileNames.length > index) ? theIdea.attachmentOrigFileNames[index] : null}
                                            theKey={index}
                                            showDropzone={false}
                                            handleAttachmentDelete={this.dummy}
                                        />
                                    </div>,
                                )}
                                </div>
                            </div>
                        }

                        {theIdea.attachmentText &&
                            <p>{theIdea.attachmentText}</p>
                        }

                        {(theIdea.moreDescription !== '' && theIdea.moreDescription !== '<p><br></p>' && theIdea.moreDescription !== '<p> </p>') &&
                            <div>
                                <h3>More Description</h3>
                                <span dangerouslySetInnerHTML={{ __html: theIdea.moreDescription }} />
                            </div>
                        }

                        <div id='ideaTools' />
                        {showToolHeading &&
                            <div>
                                <h2>Strengthen your idea</h2>
                            </div>
                        }

                        {loadedToolNames.map((majorTool, index) =>
                            <div key={index}>
                                {this.doesToolContainAnyData(majorTool) &&
                                    <div key={index + 5}>
                                        <h3 key={index + 6}>{loadedToolShowname[majorTool]}</h3>
                                        <div key={index + 7}>{loadedAllTools[majorTool].map((theTool, index) =>
                                            <div key={index + 8}>
                                                {(theIdea[majorTool][theTool.varName] && theIdea[majorTool][theTool.varName].length > 0) &&
                                                    <div key={theTool.title}>
                                                        <span key={index + 1} >{theTool.title}</span>
                                                        <br />
                                                        <span key={index + 2}>{theIdea[majorTool][theTool.varName]}</span>
                                                        <div key={index + 11} style={{ height: 10 + 'px' }} />
                                                    </div>
                                                }
                                            </div>,
                                        )}
                                        </div>
                                    </div>
                                }
                            </div>,
                        )}

                        {theIdea.timelineRows && theIdea.timelineRows.length > 0 &&
                            <div>
                                <h3>Timeline</h3>
                                <TimelineTool
                                    shouldShow={false}
                                    timelineRows={currentSteps}
                                    activeStep={theIdea.activeTimelineStep}
                                    stepperColor={theIdea.slideTextColor}
                                    activeBlipColor={theIdea.slideHeaderColor}
                                    activeCircleColor={theIdea.slideHeaderColor}
                                    completedBarColor={theIdea.slideHeaderColor}
                                    onChangeCurrentTimelinePoint={this.dummy.bind(this)}
                                    onAddRow={this.dummy.bind(this)}
                                    onEditRow={this.dummy.bind(this)}
                                    onDeleteRow={this.dummy.bind(this)}
                                />
                            </div>
                        }

                        {((theIdea.hasOwnProperty(['costRows']) && theIdea.costRows.length > 0 && theIdea.costRows[0].amount > 0) || (theIdea.hasOwnProperty(['revenueRows']) && theIdea.revenueRows.length > 0 && theIdea.revenueRows[0].amount > 0)) &&
                            <div>
                                {((theIdea.costRows[0] !== undefined && theIdea.costRows[0].what !== '') || (theIdea.revenueRows[0] !== undefined  && theIdea.revenueRows[0].what !== '')) &&
                                    <div>
                                        <h3>Economic Viability</h3>
                                    </div>
                                }
                            </div>
                        }

                        {theIdea.hasOwnProperty(['costRows']) && theIdea.costRows.length > 0 &&
                            <div>
                                {theIdea.costRows[0].amount > 0 &&
                                    <div>
                                        <strong style={{ fontSize: 20 + 'px' }}>Estimated costs</strong>
                                        <div> {theIdea.costRows.map((theRows, index) =>
                                            <div key={index} >
                                                {theRows.what !== '' &&
                                                    <div key={theRows.what}>
                                                        <span key={index} >{theRows.what}</span>
                                                        <br />
                                                        <span >{theRows.amount}</span>
                                                        <div style={{ height: 10 + 'px' }} />
                                                    </div>}
                                            </div>,
                                        )}
                                        </div>
                                        <br />
                                    </div>
                                }
                            </div>
                        }

                        {theIdea.hasOwnProperty(['costRows']) && theIdea.costRows.length > 0 &&
                            <div>
                                {theIdea.costRows[0].amount > 0 &&
                                    <div>
                                        <strong style={{ fontSize: 20 + 'px' }}>Total cost</strong>
                                        <p>{totalCost}</p>
                                        <br />
                                    </div>
                                }
                            </div>
                        }

                        {theIdea.hasOwnProperty(['revenueRows']) && theIdea.revenueRows.length > 0 &&
                            <div>
                                {theIdea.revenueRows[0].amount > 0 &&
                                    <div>
                                        <strong style={{ fontSize: 20 + 'px' }}>Estimated revenues</strong>
                                        <div> {theIdea.revenueRows.map((theRows, index) =>
                                            <div key={index}>
                                                {theRows.what !== '' &&
                                                    <div key={theRows.what}>
                                                        <span key={index} >{theRows.what}</span>
                                                        <br />
                                                        <span >{theRows.amount}</span>
                                                        <div style={{ height: 10 + 'px' }} />
                                                    </div>}
                                            </div>,
                                        )}
                                        </div>
                                        <br />
                                    </div>
                                }
                            </div>
                        }

                        {theIdea.hasOwnProperty(['revenueRows']) && theIdea.revenueRows.length > 0 &&
                            <div>
                                {theIdea.revenueRows[0].amount > 0 &&
                                    <div>
                                        <strong style={{ fontSize: 20 + 'px' }}>Total revenue</strong>
                                        <p>{totalRevenue}</p>
                                        <br />
                                    </div>
                                }
                            </div>
                        }

                        {(this.doesToolContainAnyData('viabilityText')) &&
                            <div>
                                <strong style={{ fontSize: 20 + 'px' }}>Considerations</strong>
                                <p>{theIdea.viabilityText}</p>
                            </div>
                        }

                        <div id='ideaCollaboration' />
                        {theIdea.hasOwnProperty('team') && theIdea.team.length > 0 &&
                            <div>
                                <h3>Collaborators</h3>
                                <div>{theIdea.team.map((theTeam, index) =>
                                    <div key={index}>
                                        {(theIdea.team[index] === undefined)
                                            ? <div></div>
                                            : <div key={index}>
                                                {theTeam.hasOwnProperty('teamId') &&
                                                    <span key={index + 1} >{theTeam.fullName + ' (team)'}</span>
                                                }
                                                {theTeam.hasOwnProperty('userId') &&
                                                    <div>
                                                        <span key={index + 1} >{theTeam.fullName + ' - '}</span>
                                                        <span key={index + 2} >{theTeam.email}</span>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>,
                                )}
                                </div>
                            </div>
                        }
                    </Col>
                    {((messageLength > 0 && theIdea.hasOwnProperty('status')) || (!theIdea.hasOwnProperty('status'))) &&
                        <div>
                            {(this.state.className === 'commentOpen') &&
                                <Col xs={0} sm={0} lg={3} className='commentColOpen float-right'>
                                <div className='mobileHeaderContainer'>
                                    <h3 className='mobileHeader'>Comments</h3>
                                </div>
                                    <div className='commentContainer'>
                                        <button className='btnCommentOpen' onClick={this.onCollapse.bind(this)}><Glyphicon className='commentIcon' glyph={this.state.iconState} /></button>
                                        <div className={this.state.className} id='commentOpen'>
                                            <CommentSection className='commentSection'
                                                messages={messages}
                                                userName={theUser.displayName}
                                                userPhotoURL={theUser.photoURL} viewIdeaPageContainerOpen
                                            />
                                        </div>
                                        {!theIdea.hasOwnProperty('status') &&
                                            <ChatEntry className='chatEntry'
                                                onNewMessage={this.onNewMessage.bind(this)}
                                                userName={theUser.displayName}
                                                isIdeaPage={false}
                                            />
                                        }
                                    </div>
                                </Col>
                            }
                            {(this.state.className === 'collapsed') &&
                                <Col className='commentColClosed'>
                                    <div className='commentClosedContainer'>
                                        <button className='btnCommentClosed' onClick={this.onOpen.bind(this)}><Glyphicon className='commentIcon' glyph={this.state.iconState} /></button>
                                    </div>
                                </Col>
                            }
                        </div>
                    }
                </Row>
            </Grid>
            </div>
        )
    }
}

export default inject('stores')(observer(ViewIdeaPage))



// WEBPACK FOOTER //
// ./src/containers/ViewIdeaPage.js